import React from 'react';

import * as Yup from 'yup';
import { Button, DialogActions, Grid, TextField } from '@material-ui/core';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import { useAuth } from 'hooks';
import { AutoComplete, Form, MultiSelect } from 'components';
import { call } from 'utils';
import { getRoles, ROLES } from './roles';

const initialValues = {
  user: '',
  roles: [],
  influencerCode: '',
};

const validate = Yup.object().shape({
  user: Yup.string().required('Required'),
  roles: Yup.array().of(Yup.string()).min(1, 'Select at least one role'),
  influencerCode: Yup.string().when('roles', {
    is: roles => roles.includes(ROLES.INFLUENCER),
    then: schema => schema.required('Required'),
  }),
});

const AddUserDialog = ({ users = [], ...props }) => {
  const auth = useAuth();
  const roles = getRoles(auth);

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    const user = users.find(({ id }) => values.user === id);

    if (user) {
      const influencerCode =
        Array.isArray(values.roles) && values.roles.includes(ROLES.INFLUENCER)
          ? values.influencerCode
          : undefined;

      call(props.onAdd, user, values.roles, influencerCode);
    }

    setSubmitting(false);
    resetForm();
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>Add user to group</DialogTitle>

      <Form validationSchema={validate} initialValues={initialValues} onSubmit={onSubmit}>
        {({ fieldProps, isSubmitting, values }) => (
          <>
            <DialogContent style={{ width: 450 }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <AutoComplete
                    {...fieldProps('user', 'User')}
                    items={users.map(({ id, name: text }) => ({ id, text }))}
                  />
                </Grid>

                <Grid item xs={12}>
                  <MultiSelect {...fieldProps('roles', 'Roles')} options={roles} />
                </Grid>

                {values.roles.includes(ROLES.INFLUENCER) ? (
                  <Grid item xs={12}>
                    <TextField {...fieldProps('influencerCode', 'Influencer Code')} />
                  </Grid>
                ) : null}
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button onClick={props.onClose}>cancel</Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                add
              </Button>
            </DialogActions>
          </>
        )}
      </Form>
    </Dialog>
  );
};

export default AddUserDialog;
